const urls = {
  development: "http://localhost:8080",
  test: "http://localhost",
  production: "",
};

export default urls[process.env.NODE_ENV];
